import type { FieldBindingRes, PdfBox } from './useFieldBinding.types.ts';

export type ViewMode = 'original' | 'preview';

/** Default render scale for the canvas; owned by the editor (mirrors how
 *  PlacementEditorLayout owns `scale` for PlacementCanvas). */
export const DEFAULT_CANVAS_SCALE = 1.5;

// Zoom bounds/step mirror PlacementEditorLayout's SignaturePlacementEditor.types.ts
// so the shared DocumentViewerHeader zoom controls behave identically everywhere.
export const MIN_SCALE = 0.4;
export const MAX_SCALE = 3.0;
export const SCALE_STEP = 0.2;

export interface RenderCanvasArgs {
	isPreviewMode: boolean;
	isPreviewLoading: boolean;
	previewFileResponse: Blob | undefined;
	file: Blob | string;
	bindings: FieldBindingRes[];
	selectedFieldKey: string | null;
	setSelectedFieldKey: (key: string | null) => void;
	scale: number;
	onBoxChange: (fieldKey: string, pageNum: number, pdfBox: PdfBox) => void;
	onAddBox: (pageNum: number, pdfBox: PdfBox) => void;
	onRemove: (fieldKey: string) => void;
}
